<!-- eslint-disable max-lines -->
<template>
    <el-dialog @close="closeLog" v-loading="importLoading" title="导入数据" :visible.sync="addDialog"
        :close-on-click-modal="false" :close-on-press-escape="false" width="600px">
        <el-form :model="filesForm" label-position="right" class="form-dialog" label-width="80px" ref="filesFormDialog">
            <div class="upload-btn">
                <slot name="btnSlot"></slot>
                <lots-button v-if="config.downBtn" size="mini" type="primary" @click="downLoad"
                    :loading="downloadLoading">下载模板</lots-button>
                <lots-upload-button ref="uploadRef" :text="'上传附件'" :bucket="'annto-lcrm'" @beforeUpload="beforeUploadUrl"
                    :accept="config.accept" :multiple="config.multiple" @callback="(data) => { upLoadFileUrl(data); }"></lots-upload-button>
            </div>
            <el-form-item label="附件名称：" prop="fileName">
                <span>{{ filesForm.fileName || '--' }}</span>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <lots-button size="mini" @click="closeLog">取 消</lots-button>
            <lots-button size="mini" type="primary" :disabled="!filesForm.fileUrl" @click="handleImport"
                :loading="importLoading">导入</lots-button>
        </span>
    </el-dialog>
</template>
<script>
import { ref } from '@vue/composition-api';
import { Message } from 'element-ui';
import lotsButton from '@/components/lots/lotsButton';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import { importCheckApi } from '@mdm/api/customer/customerPersonResponsibleDataApi.js';

export default {
    name: 'addFileDialog',
    props: {
        config: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    components: {
        lotsButton,
        lotsUploadButton
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // const tenantCode = store.getters.currentTenant.tenantCode;
        const currFileRow = ref({});
        const openImport = (row) => {
            addDialog.value = true;
            currFileRow.value = row;
        };
        const fileList = ref([]);
        const filesForm = ref({ fileName: '', fileUrl: '' });
        const addDialog = ref(false);
        const downloadLoading = ref(false);

        // 下载模板
        const downLoad = (data) => {
            downloadLoading.value = true;
            props.config.downloadApi({ fileName: props.config.fileName, ...(props.config.downParams || {}) }).then(res => {
                try {
                    return JSON.parse(res); // 是 JSON 对象
                } catch (e) {
                    Message.success('下载成功');
                }
            }).finally(() => { downloadLoading.value = false; });
        };
        const closeLog = () => {
            fileList.value = [];
            filesForm.value.fileName = '';
            filesForm.value.fileUrl = '';
            addDialog.value = false;
        };
        // 上传失败
        const handleError = () => {
            Message.error('上传失败');
            setupContext.emit('uploadFailHandle');
        };
        const onChange = (file) => {
            fileList.value = [];
            filesForm.value.fileName = file.name;
            fileList.value.push(file);
        };
        const importLoading = ref(false);
        // 导入
        const handleImport = async () => {
            if (!fileList.value.length) {
                return Message.warning('请先上传附件');
            }
            const params = {
                dataType: +currFileRow.value.dataType,
                fileUrl: filesForm.value.fileUrl,
                periodMonth: currFileRow.value.dataMonth,
                operationType: +currFileRow.value.operationType
            };
            // 导入文件校验接口
            importCheckApi(params).then(res => {
                if (+res.code === 0) {
                    // 把接口需要的参数带进去
                    setupContext.emit('uploadSuccessHandle', filesForm.value);
                    closeLog();
                }
            }).finally(() => {
            });
        };
        // 上传前
        const beforeUploadUrl = res => {
            // 限制文件格式
            if (props.config.accept) {
                const extension = res.file.name.split('.').pop(); // 获取文件扩展名
                const isAccept = props.config.accept.indexOf(extension) !== -1;
                if (!isAccept) {
                    Message.warning(props.config.fileType || '文件格式不对，请重新上传');
                    setupContext.refs.uploadRef.handleUploadStatus(false);
                    setupContext.refs.uploadRef.uploadDataArr = [];
                    return false; // 阻止文件上传
                }
            }

            filesForm.value.fileName = res.file.name;
            setupContext.refs.uploadRef.handleUploadStatus(true);
            return true; // 允许文件上传
        };
        const upLoadFileUrl = (res) => {
            if (res && +res.code === 0) {
                filesForm.value.fileUrl = res.data.downUrl;
                fileList.value = [{
                    fileUrl: res.data.downUrl,
                    fileName: res.data.name
                }];
            }
        };
        return {
            downLoad,
            fileList,
            filesForm,
            addDialog,
            openImport,
            downloadLoading,
            closeLog,
            handleError,
            onChange,
            importLoading,
            handleImport,
            beforeUploadUrl,
            upLoadFileUrl
        };
    }
};
</script>
<style lang="less" scope>
.upload-btn {
    display: flex;
    // padding: 0px 0px 15px 80px;
    margin: 0 0 0 8px;

    .upload-demo {
        margin-left: 10px;
    }
}
</style>
